/**
 * Auth Initializer Component
 * Checks for remembered sessions on app load
 */

import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { checkAuth } from '../store/slices/authSlice';
import { AUTH_CONFIG } from '../constants/config';

const AuthInitializer = ({ children }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    const initializeAuth = async () => {
      const token = localStorage.getItem(AUTH_CONFIG.tokenKey);
      
      // Check auth if any token exists (with or without remember me)
      if (token) {
        try {
          await dispatch(checkAuth()).unwrap();
        } catch (error) {
          // Clear invalid session data
          localStorage.removeItem(AUTH_CONFIG.tokenKey);
          localStorage.removeItem(AUTH_CONFIG.refreshTokenKey);
          localStorage.removeItem(AUTH_CONFIG.rememberMeKey);
          localStorage.removeItem(AUTH_CONFIG.userDataKey);
          localStorage.removeItem(AUTH_CONFIG.tokenKey + '_expiry');
        }
      }
    };

    initializeAuth();
  }, [dispatch]);

  return children;
};

export default AuthInitializer;
